// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rotated[data-v-4d6d37ae] {\n  -webkit-transform: rotateX(180deg);\n          transform: rotateX(180deg);\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
